export default "__VITE_ASSET__12a5a95c__"